/**
 * Ubicación de un activo en la pantalla (Fase 3). La regla de verdad vive en el servidor
 * (Servidor_Cursos_Sepe/inventario/services/ubicacion.js); aquí sólo se decide qué ENSEÑAR.
 */

/**
 * ¿El tipo tiene ubicación? Campo `provincia` (select con sus opciones) y `localidad` (texto): la
 * misma condición que el servidor. Devuelve los dos campos, o null.
 */
export function camposDeUbicacion(schema) {
  const lista = Array.isArray(schema) ? schema : [];
  const provincia = lista.find((f) => f && f.name === 'provincia' && f.type === 'select' && Array.isArray(f.options));
  const localidad = lista.find((f) => f && f.name === 'localidad' && f.type === 'string');
  return provincia && localidad ? { provincia, localidad } : null;
}

/** «Provincia (Localidad)», o null si no hay sitio. */
export const textoSitio = (provincia, localidad) => (provincia ? `${provincia}${localidad ? ` (${localidad})` : ''}` : null);
